import { useField } from 'formik';
import { Stack } from '@koob/margaret';
import { KoobInputStars } from '@koob/ui';
import { FormField, FormLabel, ErrorMessageWrapper } from 'ui/forms';

const StarsPickerField = ({ label, labelSuffix, name, ...props }) => {
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField({
    name,
    ...props,
  });
  const hasError = Boolean(touched) && Boolean(error);

  return (
    <FormField>
      <Stack
        alignX="space-between"
        alignY="center"
        marginBottom={0.5}
        size="full"
      >
        {label && <FormLabel variant="bare">{label}</FormLabel>}
        {labelSuffix}
      </Stack>

      <Stack direction="column">
        <KoobInputStars
          value={value}
          onValueChange={(value) => {
            setTouched(true);
            setValue(value);
          }}
          {...props}
        />
        {hasError && <ErrorMessageWrapper>{error}</ErrorMessageWrapper>}
      </Stack>
    </FormField>
  );
};

export default StarsPickerField;
